angular.module('components.authoring.schemaFormCollapsible', [
  'schemaForm'
])
.run(
  // [
  //   '$templateCache',
  //   '$http',
  //   function ($templateCache, $http) {
  //     'use strict';
  //     var tpl = 'components/authoring/schemaFormAddons/collapsible.html';
  //     if (!$templateCache.get(tpl)) {
  //       $http
  //         .get(tpl)
  //         .then(function(o){
  //           $templateCache.put(tpl, o.data);
  //           return;
  //         });
  //     }
  //   }
  // ]
)
.config([
  'schemaFormDecoratorsProvider',
  function (schemaFormDecoratorsProvider) {
    'use strict';

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'collapsible',
        'components/authoring/schemaFormAddons/collapsible.html'
      );
  }
]);
